import React from 'react';

import appConfig from 'appConfig';
import { CardStack, CopyInput } from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { FormattedMessage } from 'react-intl';
import summaryShape from 'Workspace/types/pluginSummary';

import { Placeholder } from './styles';
import messages from './messages';

const PluginDeveloperCard = ({ summary }) => (
  <CardStack
    icon="developer"
    title={intl.formatMessage(messages.developerTitle)}
    description={(
      <FormattedMessage
        {...messages.developerDescription}
        values={{
          developerDocsLink: <a href={`${appConfig.getDeveloperDocsURL()}/plugins/overview/`}>{intl.formatMessage(messages.developerDocsLink)}</a>,
        }}
      />
    )}
  >
    { summary ?
      <CopyInput
        value={summary.pluginId}
        label={intl.formatMessage(messages.pluginIdTitle)}
        buttonLabel={intl.formatMessage(messages.copyLabel)}
        notificationLabel={intl.formatMessage(messages.copyNotificationLabel)}
      /> :
      <Placeholder height={30} />
    }
  </CardStack>
);

PluginDeveloperCard.propTypes = {
  summary: summaryShape,
};

export default PluginDeveloperCard;
